@if (hasAnyCurrentMatches) {
<expandable class="h4"
            [expandableId]="zippyId"
            expandableIcon="chevron"
            [openAtStart]="isDefaultOpen">
    <!-- options list -->
    <div expandableTitle>
        {{label}}
        <div class="pos-absolute right-0 top-50 p1 col-12">
            {{getSelectedOptionsForFilter(app.client.isS ? 10 : 20)}}
        </div>
    </div>
    <div expandableBody>
        <div class="flex"
             [class.flex-justify-end]="isSwatch">
            <div class="w-12-s m-r-3 m-b m-b-8-m m-b-8-s"
                 [ngClass]="isSwatch ? 'w-10' : 'w-12'">
                <div [grid]="isSwatch || id === 'size' ? 2 : 1"
                     [gridColumnGap]="client.isTouchy ? 1 : 5.5"
                     [gridRowGap]="client.isTouchy ? 1 : 2.67">
                    @for (option of sortedOptionsWithMatches(); track $index; let isLast = $last) {
                    @if (getCurrentMatchesCount(option)) {
                    <div (click)="toggle(option)"
                         class="cursor-pointer flex flex-middle"
                         [ngClass]="{'m-t-2 m-b-2': !isSwatch}">
                        <!--           [gtmTrackFilterClick]="{filter: filter, option: option}" -->
                        <href [link]="option | facetUrl : filter">
                            @switch (false) {
                            <!-- @case (true) {
                            <checkbox [checked]="isSelected(option)">
                                <span class="p-l-2 p1 col-11">{{option.label}}
                                    @if (!isSwatch) {
                                    <span class="col-12">&nbsp;|&nbsp;{{getCurrentMatchesCount(option)}}</span>
                                    }
                                </span>
                            </checkbox>
                            } -->
                            @default {
                            <!-- swatch icon -->
                            @if (isSwatch) {
                            <swatch [option]="option"
                                    [selected]="isSelected(option)"
                                    [optionBig]="true"
                                    class="inline-block va-m"></swatch>
                            }
                            <!-- label -->
                            <span class="p-l-2 p1 col-11">{{option.label}}
                                @if (!isSwatch) {
                                <span class="col-12">&nbsp;|&nbsp;{{getCurrentMatchesCount(option)}}</span>
                                }
                            </span>
                            }
                            }
                        </href>
                    </div>
                    }
                    }
                </div>
            </div>
        </div>
    </div>
</expandable>
}
